// src/utils/calendarSync.js — single source of truth for workout→Calendar sync

const RUN_TYPES      = ['Long Run','Easy Run','Tempo Run','Interval'];
const STRENGTH_TYPES = ['Strength','Gym'];

export function resolveDotCategory(type) {
  if (RUN_TYPES.includes(type))      return 'training-run';
  if (STRENGTH_TYPES.includes(type)) return 'training-strength';
  return 'training-other';
}

function buildEventTitle(workout) {
  const distStr = workout.dist > 0 ? ` · ${workout.dist}mi` : '';
  const noteStr = workout.note ? ` · ${workout.note}` : '';
  return `${(workout.type||'').toLowerCase()}${distStr}${noteStr}`;
}

export function createWorkoutEvent(workout, existingEvents = []) {
  const duplicate = (existingEvents || []).some(e =>
    e.id === `train_${workout.id}` ||
    (e.date === workout.date && e.source === 'train' && e.workoutType === workout.type)
  );
  if (duplicate) return null;
  return {
    id: `train_${workout.id}`,
    title: buildEventTitle(workout),
    date: workout.date,
    time: workout.time || '07:00',
    type: 'health',
    category: 'training',
    source: 'train',
    workoutType: workout.type,
    dist: workout.dist || 0,
    dot: resolveDotCategory(workout.type),
  };
}

export function removeWorkoutEvent(workoutId, existingEvents = []) {
  return (existingEvents || []).filter(e => e.id !== `train_${workoutId}`);
}

export function syncWorkoutToCalendar(workout, setSt) {
  setSt(p => {
    const newEvent = createWorkoutEvent(workout, p.events);
    if (!newEvent) return p;
    return { ...p, events: [...(p.events || []), newEvent] };
  });
}
